import { useState, useContext, Fragment } from "react";
import { UtilityContext } from "../../context/util-context";
import Heading from "../UI/Heading";
import { MdRefresh } from "react-icons/md";
import RevenueGraph from "./RevenueGraph";
import SearchBar from "../UI/SearchBar";
import LoadingCard from "../UI/LoadingCard";
import NoRecordsFound from "../UI/NoRecordsFound";
import { requestAdminAPI } from "../../api/posh-api";
import { useLocation } from "react-router-dom";
import { toTitleCase } from "../../util/format-text";
import LoadingSpinnerWrapper from "../UI/LoadingSpinnerWrapper";
import CustomerCard from "../customers-page/CustomerCard";
import BookingCard from "../bookings-page/BookingCard";
import VehicleCard from "../vehicles-page/VehicleCard";
import PaymentCard from "../payments-page/PaymentCard";
import SamsaraLogo from "../../assets/img/samsara-logo.png";
import StripeLogo from "../../assets/img/stripe-logo.png";
import SlackLogo from "../../assets/img/slack-logo.png";
import POSHTechLogo from "../../assets/img/tech-support.png";
import GeneralInfo from "./GeneralInfo";

const quickLinks = [
  { link: "https://cloud.samsara.com/", icon: SamsaraLogo },
  { link: "https://poshcars.slack.com/ssb/redirect", icon: SlackLogo },
  { link: "https://dashboard.stripe.com/", icon: StripeLogo },
  { link: "https://poshcars.notion.site/22af618459b480e4b5dac1f37b781de0?pvs=105", icon: POSHTechLogo },
];

export default function GeneralPage() {
  const { navigate } = useContext(UtilityContext);
  const { search } = useLocation();
  const params = new URLSearchParams(search);

  // Initialize States
  const [loading, setLoading] = useState(false);
  const [limit, setLimit] = useState(5);
  const [query, setQuery] = useState(params.get("query") || "");
  const [data, setData] = useState({});

  /* ======================= SEARCH HANDLER ======================= */
  const searchHandler = async (query) => {
    try {
      setLoading(true);
      setQuery(query);
      const customers = await requestAdminAPI("search", {
        table: "customer",
        limit,
        filters: { query },
      });
      const bookings = await requestAdminAPI("search", {
        table: "booking",
        limit,
        filters: { query },
      });
      const vehicles = await requestAdminAPI("search", {
        table: "vehicle",
        limit,
        filters: { query },
      });
      const payments = await requestAdminAPI("search", {
        table: "payment",
        limit,
        filters: { query },
      });
      setData({ customers, bookings, vehicles, payments });
      setLoading(false);
    } catch (err) {
      console.error(err);

      setLoading(false);
    }
  };

  const getCard = (table, row) => {
    switch (table) {
      case "customers":
        return <CustomerCard customer={row} />;
      case "bookings":
        return <BookingCard booking={row} />;
      case "vehicles":
        return <VehicleCard vehicle={row} />;
      case "payments":
        return <PaymentCard payment={row} />;
    }
  };

  return (
    <div className="container min-h-[90vh]">
      <Heading
        title="General"
        isBackArrow={false}
        text="Following search bar returns all records. Use the search bar in the respective pages for specific records."
      >
        <MdRefresh
          className="icon"
          onClick={() => window.location.reload(false)}
        />
      </Heading>
      <SearchBar
        searchHandler={(q) => searchHandler(q)}
        clearSearch={() => setData({})}
        searchValue={query}
      />

      <div className="grid gap-4">
        {Object.keys(data).length > 0
          ? Object.keys(data).map((table, idx) => (
              <div key={idx} className="grid gap-2">
                <Heading
                  title={`${toTitleCase(table)}`}
                  onClick={(e) => navigate(`/${table}?query=${query}`, e)}
                  isBackArrow={false}
                  hideHR={true}
                />
                {loading ? (
                  <LoadingCard columns={6} max={4} />
                ) : data[table].length > 0 ? (
                  <div className="list">
                    {data[table].map((row, idx) => (
                      <Fragment key={idx}>{getCard(table, row)}</Fragment>
                    ))}
                  </div>
                ) : (
                  <NoRecordsFound />
                )}
              </div>
            ))
          : loading && <LoadingSpinnerWrapper />}
      </div>

      <GeneralInfo />

      <div className="hidden md:block">
        <RevenueGraph />
      </div>
      <div className="grid gap-4">
        <div className="info">
          {quickLinks.map((link, idx) => (
            <a
              key={idx}
              href={link.link}
              target="_blank"
              rel="noreferrer"
              className="py-2 clickable justify-items-center"
            >
              <img src={link.icon} alt="logo" className="object-contain h-8 rounded-lg" />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
